import * as types from './irr.actions';

const initialState = {
    irrs: [],
    homeGrid: {
      filterModel: null,
      sortModel: null,
      currentPage: null
    },
    fetching: true
  };

  export default function (state = initialState, action) {
    switch (action.type) {
      case types.IRRS_RECEIVED:
        console.log('IRRS_RECEIVED', action.payload);
        return {
          ...state,
          fetching: false,
          irrs: [
            ...action.payload
          ]
        };
      case types.IRRS_DELETED_IRR:
        console.log('IRRS_DELETED', action.payload);
        return {
          ...state,
          fetching: false,
          irrs: [
            ...state.irrs.filter(f => f.id != action.payload.id)
          ]
        };
        case types.IRRS_GENERATED_IRR: 
        console.log('IRRS_GENERATED', action.payload);
        return {
          ...state,
          fetching: false,
          irrs: [
            ...state.irrs
          ]
        }
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/modules/irr/irr.reducer.js